var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAddChild = function SvgIconAddChild(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10h80m-60 0v50h20",
    fill: "none",
    "data-no-fill": "true",
    stroke: "#000",
    strokeWidth: 1.2,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 60,
    r: 20,
    fill: "none",
    "data-no-fill": "true",
    stroke: "#000",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 60h20M70 50v20",
    fill: "none",
    "data-no-fill": "true",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.2
  })));
};
export { SvgIconAddChild as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAgMTAwIj4KICAgIDwhLS0gSGFuZyBsaW5lIC0tPgogICAgPHBhdGgKICAgICAgICBkPSJNMTAsMTAgTDkwLDEwIE0zMCwxMCBMMzAsNjAgTDUwLDYwIgogICAgICAgIGZpbGw9Im5vbmUiCiAgICAgICAgZGF0YS1uby1maWxsPSJ0cnVlIgogICAgICAgIHN0cm9rZT0iIzAwMCIKICAgICAgICBzdHJva2Utd2lkdGg9IjEuMiIKICAgICAgICBzdHJva2UtbGluZWpvaW49InJvdW5kIgogICAgICAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAgIC8+CiAgICA8IS0tIFBsdXMgQ2lyY2xlIC0tPgogICAgPGNpcmNsZQogICAgICAgIGN4PSI3MCIKICAgICAgICBjeT0iNjAiCiAgICAgICAgcj0iMjAiCiAgICAgICAgZmlsbD0ibm9uZSIKICAgICAgICBkYXRhLW5vLWZpbGw9InRydWUiCiAgICAgICAgc3Ryb2tlPSIjMDAwIgogICAgICAgIHN0cm9rZS13aWR0aD0iMS4yIgogICAgLz4KICAgIDwhLS0gUGx1cyBIb3Jpem9udGFsIExpbmUgLS0+CiAgICA8cGF0aAogICAgICAgIGQ9Ik02MCw2MCBMODAsNjAiCiAgICAgICAgZmlsbD0ibm9uZSIKICAgICAgICBkYXRhLW5vLWZpbGw9InRydWUiCiAgICAgICAgc3Ryb2tlPSIjMDAwIgogICAgICAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAgICAgICBzdHJva2Utd2lkdGg9IjEuMiIKICAgIC8+CiAgICA8IS0tIFBsdXMgVmVydGljYWwgTGluZSAtLT4KICAgIDxwYXRoCiAgICAgICAgZD0iTTcwLDUwIEw3MCw3MCIKICAgICAgICBmaWxsPSJub25lIgogICAgICAgIGRhdGEtbm8tZmlsbD0idHJ1ZSIKICAgICAgICBzdHJva2U9IiMwMDAiCiAgICAgICAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogICAgICAgIHN0cm9rZS13aWR0aD0iMS4yIgogICAgLz4KPC9zdmc+";